<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.main.isApplicable"
    [attr.id]="data.main.title"
  >
    <mat-slide-toggle
      [color]="data.main.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.main.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.main.isApplicable && !data.main.isPassed"
        >{{ data.main.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.main.isApplicable && !data.main.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.main.title }}
    </span>
    <div class="cases" *ngIf="data.main.isApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.safetyPlansDelivered"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.siteAtRisk"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.main.protectedAreas"
      ></authority-labs-check-value-case>
    </div>
  </section>
  <section class="check-cases" [attr.id]="data.fireAlarmSystemComponents.title">
    <span class="title" *ngIf="readonly || printPreview"
      >{{ data.fireAlarmSystemComponents.title }}
    </span>
    <div class="cases">
      <authority-labs-fire-alarm-components
        [fireAlarmComponents]="data.fireAlarmSystemComponents.components"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onComponentsChange($event)"
      ></authority-labs-fire-alarm-components>
    </div>
  </section>
  <section
    class="check-cases dialer"
    [class.border]="data.dialRiskLevelOne.isApplicable"
    [attr.id]="data.dialRiskLevelOne.title"
  >
    <authority-labs-check-dial-risk-case
      [inspection]="data.dialRiskLevelOne"
      [printPreview]="printPreview"
      [readonly]="readonly"
      (dataChange)="onDataChange()"
    ></authority-labs-check-dial-risk-case>
  </section>
  <section
    class="check-cases dialer"
    [class.border]="data.dialRiskLevelTwo.isApplicable"
    [attr.id]="data.dialRiskLevelTwo.title"
  >
    <authority-labs-check-dial-risk-case
      [inspection]="data.dialRiskLevelTwo"
      [printPreview]="printPreview"
      [readonly]="readonly"
      (dataChange)="onDataChange()"
    ></authority-labs-check-dial-risk-case>
  </section>
  <section
    class="check-cases dialer"
    [class.border]="data.dialRiskLevelTwoAccommodation.isApplicable"
    [attr.id]="data.dialRiskLevelTwoAccommodation.title"
  >
    <authority-labs-check-dial-risk-case
      [inspection]="data.dialRiskLevelTwoAccommodation"
      [printPreview]="printPreview"
      [readonly]="readonly"
      (dataChange)="onDataChange()"
    ></authority-labs-check-dial-risk-case>
  </section>
  <section
    class="check-cases"
    [class.border]="data.autoDialer.isApplicable"
    [attr.id]="data.autoDialer.title"
  >
    <mat-slide-toggle
      [color]="data.autoDialer.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.autoDialer.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.autoDialer.isApplicable && !data.autoDialer.isPassed
        "
        >{{ data.autoDialer.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.autoDialer.isApplicable && !data.autoDialer.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.autoDialer.title }}
    </span>
    <div class="cases" *ngIf="data.autoDialer.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_3"
      ></authority-labs-check-case>
      <authority-labs-check-basic-select-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_4"
        [options]="['HOT', 'בזק']"
      ></authority-labs-check-basic-select-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_5"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_6"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_7"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.autoDialer.item_4_8"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.cellularAutoDialer.isApplicable"
    [attr.id]="data.cellularAutoDialer.title"
  >
    <mat-slide-toggle
      [color]="data.cellularAutoDialer.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.cellularAutoDialer.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.cellularAutoDialer.isApplicable &&
          !data.cellularAutoDialer.isPassed
        "
        >{{ data.cellularAutoDialer.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.cellularAutoDialer.isApplicable &&
        !data.cellularAutoDialer.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.cellularAutoDialer.title }}
    </span>
    <div class="cases" *ngIf="data.cellularAutoDialer.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.cellularAutoDialer.item_5_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.cellularAutoDialer.item_5_2"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.cellularAutoDialer.item_5_3"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.cellularAutoDialer.item_5_4"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.cellularAutoDialer.item_5_5"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.discoveryHub.isApplicable"
    [attr.id]="data.discoveryHub.title"
  >
    <mat-slide-toggle
      [color]="data.discoveryHub.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.discoveryHub.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.discoveryHub.isApplicable && !data.discoveryHub.isPassed
        "
        >{{ data.discoveryHub.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.discoveryHub.isApplicable && !data.discoveryHub.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.discoveryHub.title }}
    </span>
    <div class="cases" *ngIf="data.discoveryHub.isApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_1"
      ></authority-labs-check-value-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_2"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_7"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_8"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_9"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_10"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_11"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_12"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_13"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_14"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.discoveryHub.item_6_15"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.detectorsInstallation.isApplicable"
    [attr.id]="data.detectorsInstallation.title"
  >
    <mat-slide-toggle
      [color]="data.detectorsInstallation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.detectorsInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.detectorsInstallation.isApplicable &&
          !data.detectorsInstallation.isPassed
        "
        >{{ data.detectorsInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.detectorsInstallation.isApplicable &&
        !data.detectorsInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.detectorsInstallation.title }}
    </span>
    <div class="cases" *ngIf="data.detectorsInstallation.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.detectorsInstallation.item_7_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.detectorsInstallation.item_7_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.detectorsInstallation.item_7_3"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.beamsAndPartitions.isApplicable"
    [attr.id]="data.beamsAndPartitions.title"
  >
    <mat-slide-toggle
      [color]="data.beamsAndPartitions.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.beamsAndPartitions.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.beamsAndPartitions.isApplicable &&
          !data.beamsAndPartitions.isPassed
        "
        >{{ data.beamsAndPartitions.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.beamsAndPartitions.isApplicable &&
        !data.beamsAndPartitions.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.beamsAndPartitions.title }}
    </span>
    <div class="cases" *ngIf="data.beamsAndPartitions.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.beamsAndPartitions.item_8_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.beamsAndPartitions.item_8_2_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.beamsAndPartitions.item_8_2_2"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.powerPanel.isApplicable"
    [attr.id]="data.powerPanel.title"
  >
    <mat-slide-toggle
      [color]="data.powerPanel.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.powerPanel.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.powerPanel.isApplicable && !data.powerPanel.isPassed
        "
        >{{ data.powerPanel.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.powerPanel.isApplicable && !data.powerPanel.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.powerPanel.title }}
    </span>
    <div class="cases" *ngIf="data.powerPanel.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_7"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [multiNote]="true"
        [inspection]="data.powerPanel.item_9_8"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.sirensAndMarkingLamps.isApplicable"
    [attr.id]="data.sirensAndMarkingLamps.title"
  >
    <mat-slide-toggle
      [color]="data.sirensAndMarkingLamps.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.sirensAndMarkingLamps.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.sirensAndMarkingLamps.isApplicable &&
          !data.sirensAndMarkingLamps.isPassed
        "
        >{{ data.sirensAndMarkingLamps.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.sirensAndMarkingLamps.isApplicable &&
        !data.sirensAndMarkingLamps.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.sirensAndMarkingLamps.title }}
    </span>
    <div class="cases" *ngIf="data.sirensAndMarkingLamps.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.sirensAndMarkingLamps.item_10_7"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.paSystem.isApplicable"
    [attr.id]="data.paSystem.title"
  >
    <mat-slide-toggle
      [color]="data.paSystem.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.paSystem.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="data.paSystem.isApplicable && !data.paSystem.isPassed"
        >{{ data.paSystem.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="data.paSystem.isApplicable && !data.paSystem.isPassed"
      *ngIf="readonly || printPreview"
      >{{ data.paSystem.title }}
    </span>
    <div class="cases" *ngIf="data.paSystem.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.paSystem.item_11_6"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.specialInstallations.isApplicable"
    [attr.id]="data.specialInstallations.title"
  >
    <mat-slide-toggle
      [color]="data.specialInstallations.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.specialInstallations.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.specialInstallations.isApplicable &&
          !data.specialInstallations.isPassed
        "
        >{{ data.specialInstallations.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.specialInstallations.isApplicable &&
        !data.specialInstallations.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.specialInstallations.title }}
    </span>
    <div class="cases" *ngIf="data.specialInstallations.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_1_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_1_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_2_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_2_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_3_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_3_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_4_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_4_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_4_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_7"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_8"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_9"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.specialInstallations.item_12_5_10"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.firefightersPhone.isApplicable"
    [attr.id]="data.firefightersPhone.title"
  >
    <mat-slide-toggle
      [color]="data.firefightersPhone.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.firefightersPhone.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.firefightersPhone.isApplicable &&
          !data.firefightersPhone.isPassed
        "
        >{{ data.firefightersPhone.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.firefightersPhone.isApplicable && !data.firefightersPhone.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.firefightersPhone.title }}
    </span>
    <div class="cases" *ngIf="data.firefightersPhone.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_5"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_7"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_8"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_9"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.firefightersPhone.item_13_10"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.componentsActivation.isApplicable"
    [attr.id]="data.componentsActivation.title"
  >
    <mat-slide-toggle
      [color]="data.componentsActivation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.componentsActivation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.componentsActivation.isApplicable &&
          !data.componentsActivation.isPassed
        "
        >{{ data.componentsActivation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.componentsActivation.isApplicable &&
        !data.componentsActivation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.componentsActivation.title }}
    </span>
    <div class="cases" *ngIf="data.componentsActivation.isApplicable">
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.componentsActivation.item_14_1"
      ></authority-labs-check-value-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.standaloneDetectors.isApplicable"
    [attr.id]="data.standaloneDetectors.title"
  >
    <mat-slide-toggle
      [color]="data.standaloneDetectors.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.standaloneDetectors.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.standaloneDetectors.isApplicable &&
          !data.standaloneDetectors.isPassed
        "
        >{{ data.standaloneDetectors.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.standaloneDetectors.isApplicable &&
        !data.standaloneDetectors.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.standaloneDetectors.title }}
    </span>
    <div class="cases" *ngIf="data.standaloneDetectors.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_3"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_4"
      ></authority-labs-check-case>
      <authority-labs-check-value-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_5"
      ></authority-labs-check-value-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_6_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_6_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standaloneDetectors.item_15_6_3"
      ></authority-labs-check-case>
    </div>
  </section>
</main>
